import { Splide, SplideSlide } from "@splidejs/react-splide";
import Styles from "./styles.module.css";
import Radar from "./radar/index";
import Pager from "./../pager/index";
import { IoLocationOutline, IoTrainOutline, IoChevronForward } from "react-icons/io5";
// import '@splidejs/splide/css';
import React, { useEffect, useRef, useState } from 'react';
import { getFirestore, query, collection, where, orderBy, getDocs, onSnapshot } from "firebase/firestore";
import Image1 from './../../../../image/salonType/1.png';
import Image2 from './../../../../image/salonType/2.png';
import Image3 from './../../../../image/salonType/3.png';
import Image4 from './../../../../image/salonType/4.png';
import Image5 from './../../../../image/salonType/5.png';
import Image6 from './../../../../image/salonType/6.png';
import Image7 from './../../../../image/salonType/7.png';
import Image8 from './../../../../image/salonType/8.png';
import DefaultImg from './../../../../image/default/recruit.png'

type RecruitPageStoresProps = {
  searchType: string;
  searchPref: string;
  companyId: string;
};

const RecruitPageStores: React.FC<RecruitPageStoresProps> = ({ searchType, searchPref, companyId }) => {

  const [ storeList, setStoreList ] = useState<any[]>([]);
  
  const [ time, setTime ] = useState<number>(0);

  useEffect(() => {
    const fetchStores = async () => {
      const db = getFirestore();

      try {
        const storesQuery = query(
          collection(db, "stores"),
          where("companyId", "==", companyId),
          orderBy("number", "asc")
        );

        const querySnapshot = await getDocs(storesQuery);

        const prefValue = searchPref;
        const type8Value = searchType;

        const tmp: any[] = [];

        querySnapshot.forEach((doc) => {
          const data = doc.data();
          if (!data) return;

          /* -------------------------------
          * ① 都道府県一致判定
          * ----------------------------- */

          
          const storePrefTags: string[] = Array.isArray(data.stationTags) ? data.stationTags : [];
          const prefMatch = storePrefTags.includes(prefValue);

          /* -------------------------------
          * ② 8タイプ一致判定
          * ----------------------------- */
          const storeType8 = String(data.type ?? "");
          const type8Match = storeType8 === type8Value;

          /* -------------------------------
          * ③ count 計算
          * ----------------------------- */
          const count = prefMatch ? (type8Match ? 2 : 1) : 0;

          if (data) {
            tmp.push({
              index: tmp.length,
              name: data.name,
              address: data.address,
              image: data.image,
              stationCount: data.stationCount,
              station1Name: data.station1Name,
              station1Time: data.station1Time,
              station2Name: data.station2Name,
              station2Time: data.station2Time,
              station3Name: data.station3Name,
              station3Time: data.station3Time,
              type: data.type,
              mood1: data.pentagonTreatment1,
              mood2: data.pentagonTreatment2,
              mood3: data.pentagonTreatment3,
              mood4: data.pentagonTreatment4,
              mood5: data.pentagonTreatment5,
              mood6: data.pentagonTreatment6,
              style1: data.pentagonStyle6,
              style2: data.pentagonStyle1,
              style3: data.pentagonStyle2,
              style4: data.pentagonStyle3,
              style5: data.pentagonStyle4,
              style6: data.pentagonStyle5,
              pentagonStyleInput: data.pentagonStyleInput,

              region: data.region,
              strengths: data.strengths,
              treatment: data.treatment,

              prefMatch,
              type8Match,
              count,
            });
          }
        });

        /* --------------------------------------------------
        * 🔥 ソート（Flutterと完全一致）
        * ------------------------------------------------ */
        tmp.sort((a, b) => {
          // 1. 都道府県一致を最優先
          if (a.prefMatch && !b.prefMatch) return -1;
          if (!a.prefMatch && b.prefMatch) return 1;

          // 2. 都道府県一致の中で 8タイプ一致
          if (a.type8Match && !b.type8Match) return -1;
          if (!a.type8Match && b.type8Match) return 1;

          // 3. count 降順
          return b.count - a.count;
        });

        setStoreList(tmp);
      } catch {
        // fetch error silently ignored
      }
    };

    fetchStores();
  }, [companyId, searchType, searchPref]);


  const [ pentagonSwitch, setPentagonSwitch ] = useState(true);

  const carouselRef = useRef<any>(null);
  const [ currentIndex, setCurrentIndex ] = useState(0);
  const topRef = useRef<HTMLDivElement>(null);

  const goSlide = (dir: '<' | '>') => {
    carouselRef.current?.splide.go(dir);
  };

  // サロンタイプ(学生アプリの _typeAssets と同じ対応)
  const typeOf = (d: any): { name: string; img: string } | null => {
    const key = (d.region ? 0 : 4) + (d.strengths ? 0 : 2) + (d.treatment ? 0 : 1);
    const types = [
      ['有名サロン', Image1], ['トレンドサロン', Image2], ['おしゃれサロン', Image3], ['ビューティーサロン', Image4],
      ['オールラウンドサロン', Image5], ['愛されサロン', Image6], ['密着サロン', Image7], ['こだわりサロン', Image8],
    ];
    const t = types[key];
    return t ? { name: t[0], img: t[1] } : null;
  };

  // 最寄り駅。「（福岡県）」のような括弧書きは外し、駅ごとのチップにする
  const stationsOf = (d: any): string[] => {
    const count = Number(d.stationCount) || 0;
    const out: string[] = [];
    for (let i = 1; i <= 3; i++) {
      const name = String(d[`station${i}Name`] ?? '').replace(/[（(][^）)]*[）)]/g, '').trim();
      const time = String(d[`station${i}Time`] ?? '').trim();
      if ((count === 0 || i <= count) && name) out.push(time ? `${name}　${time}` : name);
    }
    return out;
  };

  const mapUrl = (address: string) => `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;

  return (
    <>
    <div ref={topRef}>
      {storeList.length > 1 && (
        <Pager
          index={currentIndex}
          total={storeList.length}
          unit="店舗"
          onPrev={() => goSlide('<')}
          onNext={() => goSlide('>')} />
      )}
    </div>

    {storeList.length > 0 && (
      <Splide
        ref={carouselRef}
        aria-label=""
        options={{
          perPage: 1,
          arrows: false,
          type: 'slide',
          pagination: false,
          speed: 400,
        }}
        onMove={(splide, newIndex) => {
          setCurrentIndex(newIndex);
        }}
      >
        {storeList.map((data, index) => {
          const type = typeOf(data);
          const stations = stationsOf(data);
          return (
          <SplideSlide key={data.id ?? index}>
            <div className={Styles.store}>
              <img className={Styles.store_img} src={`https://firebasestorage.googleapis.com/v0/b/trankllc-com.appspot.com/o/stores%2Fresize_images%2F${data['image']}_1080x1080?alt=media&token=${time}`}
                alt=""
                onError={e => {
                  e.currentTarget.onerror = null;
                  e.currentTarget.src = DefaultImg;
                }} />
              <div className={Styles.store_body}>
                <div className={Styles.store_name}>
                  <h4>{data.name}</h4>
                  {type && (
                    <span className={Styles.type_chip}>
                      <img src={type.img} alt='' />{type.name}
                    </span>
                  )}
                </div>

                {stations.length > 0 && (
                  <div className={Styles.chips}>
                    {stations.map((st, i) => (
                      <span key={i} className={Styles.chip}><IoTrainOutline />{st}</span>
                    ))}
                  </div>
                )}

                {(data.prefMatch || data.type8Match) && (
                  <div className={Styles.chips}>
                    {data.prefMatch && <span className={Styles.badge}>検索エリア</span>}
                    {data.type8Match && <span className={Styles.badge}>検索中のタイプ</span>}
                  </div>
                )}

                {data.address && (
                  <a className={Styles.address} href={mapUrl(data.address)} target="_blank" rel="noopener noreferrer">
                    <IoLocationOutline className={Styles.address_icon} />
                    <span className={Styles.address_text}>{data.address}</span>
                    <span className={Styles.address_map}>地図<IoChevronForward /></span>
                  </a>
                )}

                <div className={Styles.divider} />

                <div className={Styles.switch}>
                  <button type="button" className={pentagonSwitch ? `${Styles.switch_chip} ${Styles.switch_on}` : Styles.switch_chip} onClick={() => setPentagonSwitch(true)}>
                    施術頻度
                  </button>
                  <button type="button" className={pentagonSwitch ? Styles.switch_chip : `${Styles.switch_chip} ${Styles.switch_on}`} onClick={() => setPentagonSwitch(false)}>
                    スタイル頻度
                  </button>
                </div>

                <Radar
                  labels={pentagonSwitch
                    ? ['カット', 'カラー', 'パーマ', '縮毛矯正', 'ヘアメイク', 'その他']
                    : [data.pentagonStyleInput ? String(data.pentagonStyleInput) : 'その他', 'かっこいい', 'トレンド', 'ナチュラル', 'クリエイティブ', 'エレガント']}
                  values={pentagonSwitch
                    ? [data.mood1, data.mood2, data.mood3, data.mood4, data.mood5, data.mood6].map((v) => (v === undefined ? 1 : v))
                    : [data.style1, data.style2, data.style3, data.style4, data.style5, data.style6].map((v) => (v === undefined ? 1 : v))} />
              </div>
            </div>
          </SplideSlide>
          );
        })}
      </Splide>
    )}
    </>
  );
}

export default RecruitPageStores;
